export const FES_PLOT_BUTTON_ID = 'FESPlotButton';
